import { action } from "typesafe-actions";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../../api/api";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../../messages/messagesActions";
import {
  IPaymentRecord,
  ISinglePaymentRecord,
} from "./PaymentAccountsRecievable.types";
import { IFileUpload } from "../../../features/FileUpload/components/FileUpload.type";
import { getUniqueId } from "../../../helpers";
import { makeApiCall } from "../../../helpers/postRequest";
import { IInvoiceInformation } from "../InvoiceInformation/InvoiceInformation.types";
import { IDataTableV2DateState } from "../../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { IDatatableV2AdvancedSearchFilter } from "../../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";
import { uploadMultipleFile } from "../../../features/FileUpload/utils";

export const FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_LIST_PROGRESS =
  "FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_LIST_PROGRESS";
export const FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_LIST_SUCCESS =
  "FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_LIST_SUCCESS";
export const FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_LIST_FAILURE =
  "FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_LIST_FAILURE";

export const fetchAccountingPaymentAccountsRecievableListProgress = () =>
  action(FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_LIST_PROGRESS);

export const fetchAccountingPaymentAccountsRecievableListSuccess = (
  data: IPaymentRecord[],
  totalRecords: number,
) =>
  action(FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_LIST_SUCCESS, {
    data,
    totalRecords,
  });

export const fetchAccountingPaymentAccountsRecievableListFailed = (
  errorMessage: string,
) =>
  action(FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_LIST_FAILURE, {
    errorMessage,
  });

export const fetchAccountingPaymentAccountsRecievableListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    status: string,
    date: IDataTableV2DateState["dates"],
    searchValue: IDatatableV2AdvancedSearchFilter,
    policyId?: any,
    paymentMethod?: string,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchAccountingPaymentAccountsRecievableListProgress());
      const paymentUrl = "/accounting/get-account-payment-accounts-receivable";
      const draftPaymentUrl =
        "/accounting/get-account-payment-accounts-receivable-draft";
      let finalUrl = `${status === "DRAFT" ? draftPaymentUrl : paymentUrl}?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}`;
      if (searchValue.length > 0) {
        finalUrl = `${status === "DRAFT" ? draftPaymentUrl : paymentUrl}?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${
          date.fromDate
        }&to_date=${date.toDate}&advanceFilter=${JSON.stringify(searchValue)}`;
      }
      if (status !== "-1") {
        finalUrl += "&status=" + status;
      }

      if (paymentMethod && paymentMethod !== "-1") {
        finalUrl += "&column=payment_method&value=" + paymentMethod;
      }

      if (policyId) {
        finalUrl = finalUrl + "&policy_id=" + policyId;
      }
      const res = await api.get(finalUrl);
      const data: IPaymentRecord[] = res.data.data;
      const finalData: IPaymentRecord[] = [];

      if (data.length > 0) {
        for (const item of data) {
          const attachments: IFileUpload[] = [];
          for (const file of (item.file_upload || []) as any) {
            if (typeof file === "string") {
              attachments.push({
                file: null,
                key: getUniqueId(),
                path: file,
              });
            } else {
              attachments.push(file);
            }
          }
          finalData.push({
            ...item,
            file_upload: attachments,
          });
        }
      }

      dispatch(
        fetchAccountingPaymentAccountsRecievableListSuccess(
          finalData,
          res.data.totalRecords,
        ),
      );
    } catch (err: any) {
      dispatch(
        fetchAccountingPaymentAccountsRecievableListFailed(
          "Something went to be wrong!",
        ),
      );
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };

export const FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_PROGRESS =
  "FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_PROGRESS";
export const FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_SUCCESS =
  "FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_SUCCESS";
export const FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_FAILURE =
  "FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_FAILURE";

export const fetchAccountingPaymentAccountsRecievableProgress = () =>
  action(FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_PROGRESS);

export const fetchAccountingPaymentAccountsRecievableSuccess = (
  data: ISinglePaymentRecord,
) => action(FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_SUCCESS, { data });

export const fetchAccountingPaymentAccountsRecievableFailed = (
  errorMessage: string,
) =>
  action(FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_FAILURE, {
    errorMessage,
  });

export const fetchAccountingPaymentAccountsRecievableAsync =
  (paymentId: number): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchAccountingPaymentAccountsRecievableProgress());
      const res = await api.get(
        `/accounting/get-account-payment-accounts-receivable?payment_id=${paymentId}`,
      );
      const data: ISinglePaymentRecord[] = res.data.data;
      if (data.length > 0) {
        const attachments: IFileUpload[] = [];
        for (const item of (data[0].file_upload || []) as any) {
          attachments.push({
            file: null,
            key: getUniqueId(),
            path: item,
          });
        }
        dispatch(
          fetchAccountingPaymentAccountsRecievableSuccess({
            ...data[0],
            // file_upload: attachments,
          }),
        );
      }
    } catch (err: any) {
      dispatch(
        fetchAccountingPaymentAccountsRecievableFailed(
          "Something went to be wrong!",
        ),
      );
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };

export const addAccountingPaymentAccountsRecievableAysnc =
  (
    data: ISinglePaymentRecord,
    initialData: ISinglePaymentRecord,
    isUpdate: boolean,
    onCallback: (isSuccess: boolean) => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      // const asPayload = {
      //   invoice_id: data.invoice_id,
      // };
      // const { paths } = await uploadMultipleFile(
      //   data.file_upload || [],
      //   "ACCOUNTING",
      //   asPayload
      // );

      await makeApiCall(
        {
          url: "/accounting/edit-account-payment-accounts-receivable",
          method: "POST",
          automation: {
            isUpdate: isUpdate,
            primaryFieldName: "invoice_id",
          },
        },
        initialData,
        {
          ...data,
          // file_upload: paths,
        },
      );

      const message = "Payment Accounts Recievable saved successfully.";
      dispatch(
        showMessage({
          type: "success",
          message: message,
          displayAs: "snackbar",
        }),
      );
      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const addAccountingBulkPaymentAysnc =
  (
    data: IPaymentRecord[],
    onCallback: (isSuccess: boolean) => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      const finalData: IPaymentRecord[] = [];
      for (const item of data) {
        const record = { ...item };
        if (!record.file_upload || record.file_upload.length === 0) {
          finalData.push(record);
          continue;
        }
        const asPayload = {
          customer_id: record.customerId,
          customer_policy_id: record.policy_id,
          page_name: "Bulk Invoice Payment",
          invoice_id: record.invoice_id,
        };
        const path = await uploadMultipleFile(
          record.file_upload,
          "ACCOUNTING",
          asPayload,
        );
        record.file_upload = path.paths as any;
        finalData.push(record);
      }

      const res = await api.post("/accounting/insert-bulk-invoices-and-bills", {
        INVOICE_PAYMENTS: finalData,
      });
      const message = "Payment saved successfully.";
      dispatch(
        showMessage({
          type: "success",
          message: message,
          displayAs: "snackbar",
        }),
      );
      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const updateMultipleStatusOfPaymentAccountsRecievable =
  (
    data: IPaymentRecord[],
    onCallback: (isSuccess: boolean) => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      await api.post("/accounting/insert-bulk-invoices-and-bills", {
        INVOICE_PAYMENTS: data.map((item) => ({
          ...item,
          status: "ACTIVE",
        })),
      });
      const message = "Payments Approved successfully.";
      dispatch(
        showMessage({
          type: "success",
          message: message,
          displayAs: "snackbar",
        }),
      );
      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const downloadReceiptPDFAsync =
  (
    payment_id: number,
    getBufferOnly?: (buffer: string) => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      const res = await api.get(
        `/accounting/get-account-payment-accounts-receivable-pdf?payment_id=${payment_id}`,
        {
          responseType: "arraybuffer",
        },
      );

      const pdfBuffer = res.data;

      const pdfBlob = new Blob([pdfBuffer], { type: "application/pdf" });

      if (getBufferOnly) {
        getBufferOnly(pdfBuffer);
        return;
      }

      const pdfUrl = URL.createObjectURL(pdfBlob);

      const link = document.createElement("a");
      link.href = pdfUrl;
      link.download = "Payment Receipt.pdf";
      link.click();

      URL.revokeObjectURL(pdfUrl);
    } catch (err: any) {
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const fetchInvoicesByPolicyNumberAsync =
  (
    policyId: string,
    onCallback: (data: IInvoiceInformation[]) => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      const finalUrl = `/accounting/get-account-invoice?policy_id=${policyId}&column=agency_or_direct_bill&value=A&status=ACTIVE`;
      const res = await api.get(finalUrl);
      let data: IInvoiceInformation[] = res.data.data;
      data = data.sort((x, y) => {
        if (x.invoice_id && y.invoice_id && x.invoice_id > y.invoice_id) {
          return 1;
        }
        return -1;
      });

      onCallback(data);
    } catch (err: any) {
      onCallback([]);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const fetchInvoicesByuserCodeAsync =
  (
    code: string,
    onCallback: (data: IInvoiceInformation[]) => void,
    brokerCode?: string,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      let finalUrl = `/accounting/get-account-invoice?code=${code}&status=ACTIVE`;
      if (brokerCode) {
        finalUrl = finalUrl + `&broker_code=` + brokerCode;
      }
      const res = await api.get(finalUrl);
      let data: IInvoiceInformation[] = res.data.data;
      data = data.sort((x, y) => {
        if (x.invoice_id && y.invoice_id && x.invoice_id > y.invoice_id) {
          return 1;
        }
        return -1;
      });

      onCallback(data);
    } catch (err: any) {
      onCallback([]);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const downloadPaymentInvoiceInformationPDFAsync =
  (
    payment_id: number,
    onCallback: () => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      const res = await api.get(
        `/accounting/get-account-payment-accounts-receivable-pdf?payment_id=${payment_id}`,
        {
          responseType: "arraybuffer",
        },
      );

      const pdfBuffer = res.data;

      const pdfBlob = new Blob([pdfBuffer], { type: "application/pdf" });

      const pdfUrl = URL.createObjectURL(pdfBlob);

      const link = document.createElement("a");
      link.href = pdfUrl;
      link.download = "Payment Receipt.pdf";
      link.click();

      URL.revokeObjectURL(pdfUrl);
      onCallback();
    } catch (err: any) {
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const previewPaymentInvoiceInformationPDFAsync =
  (
    payment_id: number,
    onCallback: () => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      const res = await api.get(
        `/accounting/get-account-payment-accounts-receivable-pdf?payment_id=${payment_id}&is_payment_receivable_preview=true`,
      );

      for (const key in res.data.data) {
        const newTab = window.open("", "_blank");
        if (newTab) {
          newTab.document.write(res.data.data[key]);
          newTab.document.close();
        }
      }
      onCallback();
    } catch (err: any) {
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const UPDATE_INVOICE_PAYMENT_RECONCILIATION_STATUS =
  "UPDATE_INVOICE_PAYMENT_RECONCILIATION_STATUS";
export const updateInvoicePaymentReconciliationStatus = (
  paymentIds: number[],
  reconciled: string,
  reconciledDate: string,
) =>
  action(UPDATE_INVOICE_PAYMENT_RECONCILIATION_STATUS, {
    paymentIds,
    reconciled,
    reconciledDate,
  });

export const updateReconciledStatusofInvoicePayment =
  (
    data: {
      payment_id: number[];
      reconciled: string;
      reconciled_date: string | null;
    },
    onCallback: (isSuccess: boolean) => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      await api.put("/accounting/update-reconciliation-status", {
        type: "invoice_payments_receivable",
        primary_id: data.payment_id,
        reconciled: data.reconciled,
        reconciled_date: data.reconciled_date,
      });
      const message = "Bill reconciled successfully.";
      dispatch(
        showMessage({
          type: "success",
          message: message,
          displayAs: "snackbar",
        }),
      );
      dispatch(
        updateInvoicePaymentReconciliationStatus(
          data.payment_id,
          data.reconciled,
          data.reconciled_date as string,
        ),
      );
      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const CLEAR_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE =
  "CLEAR_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE";
export const clearAccountingPaymentAccountsRecievable = () =>
  action(CLEAR_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE);
